export const deduplicate = <T>(items: Iterable<T>, getKey: (item: T) => string | number): T[] => {
  const used = new Set<string | number>();
  const base: readonly T[] = Array.isArray(items) ? items : Array.from(items);
  return base.filter((item) => {
    const key = getKey(item);
    if (used.has(key)) {
      return false;
    }
    used.add(key);
    return true;
  });
};

export const deduplicateDividers = <T>(items: readonly T[], isDivider: (item: T) => boolean): T[] => {
  let hasHadNonDivider = false;
  return items.filter((item, i) => {
    if (!isDivider(item)) {
      hasHadNonDivider = true;
      return true;
    }
    if (!hasHadNonDivider || i === items.length - 1) return false;
    const next = items[i + 1];
    return !isDivider(next);
  });
};
